export default __webpack_public_path__ + "0f1c9b4b9d48f2b18d49bce09b1465a7.svg";